import { Loader } from '@googlemaps/js-api-loader'
import GOOGLE_API from '../../constants/googleAPIConstants'
import { IListingForBoundsParams } from './types'
import {
  MAX_FETCHED_LISTINGS,
  PAGE_COUNT,
} from '../../constants/paginationConstants'

export const filterListingsForBounds = async ({
  listings,
  bounds,
  filtered,
  triangle,
}: IListingForBoundsParams) => {
  if (bounds !== null && !isNaN(bounds.NE.lat)) {
    const { NE, SW } = bounds
    const ix = NE.lat
    const iy = NE.lng
    const ax = SW.lat
    const ay = SW.lng
    const loader = new Loader(GOOGLE_API)
    const google = await loader.importLibrary('geometry')
    const google2 = await loader.importLibrary('core')

    const filteredListings = listings.filter((listing) => {
      const { latitude, longitude } = listing.address
      if (
        ix >= latitude &&
        latitude >= ax &&
        iy >= longitude &&
        longitude >= ay
      ) {
        if (filtered && triangle) {
          return triangle.some((polygon: any) => {
            return google.poly.containsLocation(
              new google2.LatLng(latitude, longitude),
              polygon
            )
          })
        }
        return true
      }
      return false
    })
    return filteredListings
  }
  return listings
}

export const getSliceValues = (pageNumber: number) => {
  return {
    sliceEnd: PAGE_COUNT * pageNumber,
    sliceStart: PAGE_COUNT * (pageNumber - 1),
  }
}

export const getRemainingPageParams = (params: any, totalCount: number) => {
  const { page, pageCount } = params
  const fetchableCount = Math.min(totalCount, MAX_FETCHED_LISTINGS)
  const totalPages = Math.ceil(fetchableCount / pageCount)
  const remainingPages = []

  for (let nextPage = page + 1; nextPage <= totalPages; nextPage++) {
    remainingPages.push({ ...params, page: nextPage })
  }

  return remainingPages
}
